import * as api from '../../api/encargado-cia-client';
import { 
    GET_CONFIG_FORM,
    GET_CRITERIOS_FECHA,
    GET_DECLARACION_POLICIAL,
    GET_ESTADOS_CASO,
    GET_SITUACION_SINIESTRO,
    GET_TAREAS,
    GET_TIPO_GESTION,
    GET_TAREAS_USUARIO,
    GET_CASOS_BANDEJA,
    GET_RANGO_FECHAS,
    GET_XLS_CASOS_BANDEJA,
    CLEAR_CASOS_BANDEJA,
    GET_INSTANCIA_JUDICIAL,
    GET_IND_LESIONADOS,
    GET_ASIGNA_GESTION
} from '../types';


export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORM,
    payload: api.getConfiguracionForm(query)
});

export const obtenerTareasAction = (query) => ({
    type: GET_TAREAS,
    payload: api.getTareas(query)
});

export const obtenerEstadosCasoAction = (query) => ({
    type: GET_ESTADOS_CASO,
    payload: api.getConceptos(query)
});

export const obtenerTipoGestionAction = (query) => ({
    type: GET_TIPO_GESTION,
    payload: api.getConceptos(query)
});

export const obtenerSituacionSiniestroAction = (query) => ({
    type: GET_SITUACION_SINIESTRO,
    payload: api.getConceptos(query)
});

export const obtenerDeclaracionPolicialAction = (query) => ({
    type: GET_DECLARACION_POLICIAL,
    payload: api.getConceptos(query)
});

export const obtenerCriteriosFechaAction = (query) => ({
    type: GET_CRITERIOS_FECHA,
    payload: api.getConceptos(query)
});

export const obtenerTareasUsuarioAction = (query) => ({
    type: GET_TAREAS_USUARIO,
    payload: api.getTareasUsuario(query)
});

export const obtenerCasosBandeja = (query) => ({
    type: GET_CASOS_BANDEJA,
    payload: api.getCasosBandeja(query)
});
export const obtenerRangoFechas = (query) => ({
    type: GET_RANGO_FECHAS,
    payload: api.getRangoFechas(query)
});
export const obtenerXlsCasosBandeja = (query) => ({
    type: GET_XLS_CASOS_BANDEJA,
    payload: api.getXlsCasosBandeja(query)
});
export const limpiarCasosBandeja = () => ({
    type: CLEAR_CASOS_BANDEJA,
    payload: { casos: [], query: null }
});
export const obtenerInstanciaJudicial = (query) => ({
    type: GET_INSTANCIA_JUDICIAL,
    payload: api.getIntanciaJudicial(query)
});
export const obtenerIndLesionados = (query) => ({
    type: GET_IND_LESIONADOS,
    payload: api.getConceptos(query)
});
export const obtenerAsignaGestion = (query) => ({
    type: GET_ASIGNA_GESTION,
    payload: api.getConceptos(query)
});